import * as React from "react";
import {Breadcrumbs, Typography, Container, Button, Box, Stack} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {useAdviceList} from "./hook/useAdviceList";
import AdviceItem from "./AdviceItem";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Slider from "react-slick";
import slickSettings from "../../slickSettings";
import AdviceItemPlaceholder from "../advice/AdviceItemPlaceholder";

import './advice.css';

const Advice = () => {
    const navigate = useNavigate();
    const {advices, isLoading} = useAdviceList();
    return (
        <Box>
            <Container maxWidth={"lg"}>
                <Breadcrumbs separator="›" aria-label="breadcrumb">
                    {[
                        <Typography className={'text-gradient2 breadcrumbs'} variant={'body2'} onClick={() => navigate('/')} >
                            Accueil
                        </Typography>,
                        <Typography className={'text-gradient2 breadcrumbs'} variant={'body2'}>
                            Conseils
                        </Typography>,
                    ]}
                </Breadcrumbs>
                <Typography variant='h2' marginTop={5} sx={{marginBottom: '40px'}}>
                    MES CONSEILS
                </Typography>
                {
                    isLoading && <Stack
                        direction="row"
                        justifyContent="left"
                        alignItems="center"
                        spacing={5}
                    >
                        <AdviceItemPlaceholder/>
                        <AdviceItemPlaceholder/>
                        <AdviceItemPlaceholder/>
                    </Stack>
                }
                {advices.length >= 3 ?
                    <Slider {...slickSettings}>
                        {
                            !isLoading && advices.map( (advice, index) => <AdviceItem {...advice} key={index} controls={['show-detail']} treadingBadge={true}/> )
                        }
                    </Slider>:
                    <Stack
                        direction="row"
                        justifyContent="left"
                        alignItems="center"
                        spacing={5}
                    >
                        {!isLoading && advices.map( (advice, index) => <AdviceItem {...advice} key={index} controls={['show-detail']} treadingBadge={true}/> )}
                    </Stack>

                }
            </Container>
        </Box>
    )
}

export default Advice;